export default theme => ({
  root: {},
  row: {
    alignItems: "center",
    // backgroundColor: theme.palette.common.white,
    backgroundColor: theme.palette.background.default, // <Paper> has default color white, so background color of this element had to be
    // overwritten by the default background color of entire portal
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(0),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0)
  },
  listOfConnectors: {
    marginBottom: theme.spacing(2)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput: {
    marginRight: theme.spacing(1),
    background: theme.palette.common.muted
  },
  rowContent: {
    marginRight: "10px",
    marginLeft: "10px"
  },
  listHeader: {
    justifyContent: "space-between"
  },
  numberOfConnections: {
    flexGrow: 99,
    paddingLeft: "10px",
    color: theme.palette.common.muted,
    WebkitUserSelect: "none" /* Safari */,
    MozUserSelect: "none" /* Firefox */,
    MsUserSelect: "none" /* IE10+/Edge */,
    userSelect: "none" /* Standard */
  },
  noSelect: {
    WebkitUserSelect: "none" /* Safari */,
    MozUserSelect: "none" /* Firefox */,
    MsUserSelect: "none" /* IE10+/Edge */,
    userSelect: "none" /* Standard */
  }
});
